import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'
import { draftOrderPartial } from './partials'

const fetchDraftOrdersQuery = `
  query ShopifyFetchDraftOrders(
    $query: String!,
    $limit: Int!
  ) {
    draftOrders(first: $limit, query: $query, reverse: true) {
      edges {
        node {
          ${draftOrderPartial}
        }
      }
    }
  }
`

const doFetchDraftOrders = (integrationId, customerGid, limit) => dispatch => {
  const query = `customer_id:${customerGid.split('/').pop()} status:OPEN`
  const variables = { query, limit }

  return dispatch(
    doGraphqlRequest(
      types.FETCH_DRAFT_ORDERS_REQUEST,
      fetchDraftOrdersQuery,
      variables,
      {
        graphqlFunc: graphql(integrationId),
      }
    )
  )
}

export default doFetchDraftOrders
